import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { FunctionalLocation } from '../models/functional-location.model';

@Injectable({
  providedIn: 'root',
})
export class FunctionalLocationService {
  constructor(private apiService: ApiService) {}

  public GetByWorkCenter(
    workCenterId: string,
  ): Observable<FunctionalLocation[]> {
    return this.apiService.get<FunctionalLocation[]>(
      `/FunctionalLocation/GetByWorkCenter/${workCenterId}`,
    );
  }
}
